import React from "react";
import { Box, Button, IconButton, TextField } from "@mui/material";
import { formCols } from "./utils";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useForm } from "../../../../hooks/formHook";
import { addNewVendor } from "./api";
import CancelIcon from "@mui/icons-material/Cancel";

export default function AddNewForm({
  newFormOpen,
  setNewFormOpen,
  setVendors,
  vendors,
}) {
  const { onChange, onSubmit, values } = useForm(addVendorCallback, {
    name: "",
    email: "",
  });

  async function addVendorCallback() {
    console.log("DATA:", values);
    const res = await addNewVendor(1, values);
    setVendors([...vendors, res[0]]);
  }

  const onAddVendor = (e) => {
    onSubmit(e);
    setNewFormOpen(false);
  };

  return (
    <Box
      sx={{
        textAlign: "left",
        px: 2,
        display: newFormOpen ? "flex" : "none",
        alignItems: "center",
        // border: "1px solid red",
        backgroundColor: "#efefef",
      }}
    >
      {formCols.map((formCol) => {
        return (
          <Box
            sx={{
              minWidth: formCol.minWidth,
              textAlign: formCol.align,
              display: "inline-block",
            }}
            key={formCol.id}
          >
            {formCol.id === "name" ? (
              <TextField
                id="name"
                name="name"
                label="Name"
                autoComplete="off"
                onChange={onChange}
                value={values.name}
                variant="standard"
                sx={{ m: 1, mt: 0 }}
              />
            ) : formCol.id === "email" ? (
              <TextField
                id="email"
                name="email"
                label="Email"
                autoComplete="off"
                onChange={onChange}
                value={values.email}
                variant="standard"
                sx={{ m: 1, mt: 0 }}
              />
            ) : formCol.id === "actions" ? (
              <Box sx={{ textAlign: "right" }}>
                <Button
                  variant="contained"
                  endIcon={<PersonAddAlt1Icon />}
                  onClick={(e) => onAddVendor(e)}
                >
                  Add Vendor
                </Button>

                {/* <Button endIcon={<CancelIcon />}>cancel</Button> */}
                <IconButton
                  color="error"
                  onClick={() => setNewFormOpen(false)}
                  aria-label="delete"
                >
                  <CancelIcon />
                </IconButton>
              </Box>
            ) : (
              ""
            )}
          </Box>
        );
      })}
    </Box>
  );
}
